import React from 'react';
import { CTAButton } from '../CTAButton';
import { SectionHeading } from './SectionHeading';
import { soundsLikeYou } from '../../data/transformation';
export function SoundsLikeYou() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-202" data-mp="1bcytbewt2atz">
      <div className="mx-auto w-full max-w-4xl" data-id="element-203" data-mp="1bbnpxg79v53e">
        <SectionHeading eyebrow="Does This Sound Like You?" title="If you’ve ever experienced one of these situations, this system was designed for you" data-id="element-204" data-mp="1gbjpn38xsad5" />

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-205" data-mp="nn4guygeeoa9">
          {soundsLikeYou.map(item => <li key={item.title} className="flex gap-3.5 rounded-2xl border-l-4 border-gold-500 bg-bone p-4 sm:p-5" data-id="element-206" data-mp="smqqyz0xjoeu">
              <span aria-hidden="true" className="mt-0.5 text-2xl leading-none" data-id="element-207" data-mp="xfjzlxzirgw7">
                {item.icon}
              </span>
              <div data-id="element-208" data-mp="4wwewjofq3vn">
                <h3 className="text-[15px] font-bold leading-snug text-navy-950" data-id="element-209" data-mp="4wef5d2kd7iz">{item.title}</h3>
                <p className="mt-1.5 text-[13.5px] leading-relaxed text-slate-600" data-id="element-210" data-mp="y3w38x7oy3fw">{item.text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-md" data-id="element-211" data-mp="of4f705r43a9">
          <CTAButton label="Yes, that’s exactly me" subline="$27 USD — one-time payment, lifetime access" data-id="element-212" data-mp="odta8x0kkphk" />
        </div>
      </div>
    </section>;
}